import { unifyParams } from '../../../utils/unifyParams'
import apinode from '../../apinode'

class WmsOsService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll(status) {
    const response = await apinode.get(
      `/wmsOs/${this.idconta}?status=${status}`,
    )

    return response.data
  }

  async getBySearch({
    numos,
    numtrans,
    codoper,
    codenderecoorig,
    codendereco,
    sku,
    tipoos,
    status,
  }) {
    console.log(status)
    const url = unifyParams(`wmsOs/search/${this.idconta}`, [
      {
        key: 'numos',
        value: numos,
      },
      {
        key: 'numtrans',
        value: numtrans,
      },
      {
        key: 'codoper',
        value: codoper,
      },
      {
        key: 'codenderecoorig',
        value: codenderecoorig,
      },
      {
        key: 'codendereco',
        value: codendereco,
      },
      {
        key: 'sku',
        value: sku,
      },
      {
        key: 'tipoos',
        value: tipoos,
      },
      {
        key: 'status',
        value: status,
      },
    ])

    const response = await apinode.get(url)

    return response.data
  }

  async reverse(osId, funcId) {
    await apinode.patch(`/wmsOs/reverse/${osId}/${this.idconta}`, {
      funcId,
    })
  }

  async assignEmployee(selectedOs, idFuncionario) {
    await apinode.patch(`/wmsOs/${this.idconta}`, { selectedOs, idFuncionario })
  }
}

export default new WmsOsService()
